/// <amd-module name="Wit/SprintsHub/Common/TaskboardWorkItem" />
import { IObservableValue, ObservableValue } from "VSS/Core/Observable";
import { ClientWorkItem } from "Wit/ClientWorkItemService/IClientWorkItem";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { IFieldEntry } from "Wit/Common/Generated/Contracts";
import { ITaskboardWorkItem } from "Wit/SprintsHub/Common/Contracts/Interfaces";
import { INamedFieldDataDictionary } from "Wit/WorkItemDataManager/Contracts";

export class TaskboardWorkItem extends ClientWorkItem implements ITaskboardWorkItem {
    public grayedOut: IObservableValue<boolean>;
    public filteredOut: IObservableValue<boolean>;
    public isTitleEditing: IObservableValue<boolean>;
    public queuedForRemoving: IObservableValue<boolean>;
    public parentId: IObservableValue<number>;
    public state: IObservableValue<string>;

    public constructor(fields: INamedFieldDataDictionary, referenceFields?: IFieldEntry[]) {
        super(fields, referenceFields);

        this.isTitleEditing = new ObservableValue<boolean>(false);
        this.filteredOut = new ObservableValue(false);
        this.grayedOut = new ObservableValue(false);
        this.queuedForRemoving = new ObservableValue(false);
        this.parentId = new ObservableValue(fields.ParentId);
        this.state = new ObservableValue(fields[CoreFieldRefNames.State].toLocaleLowerCase());
    }
}
